import { InlineStack, Icon, Text, Tooltip } from "@medentic/polaris-react";
import type { IconProps, TextProps } from "@medentic/polaris-react";

interface IconWithValueAndTooltipProps {
  iconSource?: IconProps['source'];
  value: string | number;
  tooltip?: string;
  iconTone?: IconProps['tone'];
  textVariant?: TextProps['variant'];
  textTone?: TextProps['tone'];
  alignment?: TextProps['alignment'];
}

export default function IconWithValueAndTooltip({
  iconSource,
  value,
  tooltip,
  iconTone = "base",
  textVariant = "bodySm",
  textTone = "base",
  alignment = "start",
}: IconWithValueAndTooltipProps) {
  const isNumber = typeof value === 'number';
  const formattedValue = isNumber 
    ? value.toLocaleString('en-US')
    : value;
  
  const finalTextTone = isNumber && value > 0
    ? "base"
    : textTone;

  const content = (
    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <InlineStack gap="100" align="end" blockAlign="start" wrap={false} as="span">
        {iconSource && (
          <Icon source={iconSource} tone={iconTone} />
        )}
        <Text as="span" variant={textVariant} tone={finalTextTone} alignment={alignment}>
          {formattedValue}
        </Text>
      </InlineStack>
    </span>
  );

  if (tooltip) {
    return (
      <Tooltip content={tooltip}>
        {content}
      </Tooltip>
    );
  }

  return content;
}
